var map = {
	"./ar/main/MainView.vue": [
		73481,
		481
	],
	"./en/main/MainView.vue": [
		19537,
		537
	],
	"./kr/main/MainView.vue": [
		38962,
		962
	],
	"./mn/main/MainView.vue": [
		19621,
		621
	],
	"./ru/main/MainView.vue": [
		92560,
		560
	],
	"./zh/main/MainView.vue": [
		95481,
		862
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 54566;
module.exports = webpackAsyncContext;